import { render, staticRenderFns } from "./ErrorTbk.vue?vue&type=template&id=406c0cf4&lang=pug&"
import script from "./ErrorTbk.vue?vue&type=script&lang=js&"
export * from "./ErrorTbk.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTbk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports